import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import SubsidyDateTimeSetting from 'forms/AdminBulkOrderForm/SubsidyDateTimeSetting';
import AutoSelect from 'forms/AdminBulkOrderForm/AutoSelect';
import { getDefaultMealItem } from 'forms/AdminBulkOrderForm/helpers';
import { getRestaurantMealsByRestaurantByIsActive } from 'forms/AdminBulkOrderForm/queries';
import { asyncListAll } from 'utilities/graph';

const MealItemsWidget = (props) => {
  const { registry, onChange } = props;
  const [mealItems, setMealItems] = useState(registry?.formContext?.formData?.mealItems || []);
  const [restaurantId, setRestaurantId] = useState(registry?.formContext?.formData?.restaurantId);
  const [mealOptionsList, setMealOptionsList] = useState({});

  const getMealOptions = async (restaurantId) => {
    if (!restaurantId) {
      return;
    }
    if (!mealOptionsList[restaurantId]) {
      const mealOptions = await asyncListAll(
        getRestaurantMealsByRestaurantByIsActive, { restaurantId });
      mealOptionsList[restaurantId] = mealOptions;
      setMealOptionsList(mealOptionsList);
    }
    return mealOptionsList[restaurantId];
  };

  const updateMealItems = async (formData) => {
    const mealOptions = await getMealOptions(formData.restaurantId);

    if (!formData || !formData?.restaurantId || formData?.restaurantId === restaurantId) return;

    if (mealOptions.length) {
      if (formData.mealItems) {
        const newMealItems = [];
        const { name, price = 0, cost = 0, surcharges = [] } = mealOptions[0];
        formData.mealItems.forEach((mealItem) => {
          newMealItems.push({
            ...mealItem,
            name,
            price,
            cost,
            surcharges: surcharges || [],
          });
        });
        setMealItems(newMealItems);
        onChange(newMealItems);
      }
    }
  };

  useEffect(() => {
    const formData = registry?.formContext?.formData;
    console.log('contextFormData', formData);
    updateMealItems(formData);
    setRestaurantId(formData?.restaurantId);
  }, [registry]);

  const handleUpdate = (updatedMealItems) => {
    setMealItems(updatedMealItems);
    onChange(updatedMealItems);
  };

  return (
    <>
      {mealItems && mealItems.map((mealItem, index) => {
        return (
          <Grid container spacing={1} key={`mealItem-${index}`}>
            <Grid item md={4}>
              <AutoSelect
                options={mealOptionsList[restaurantId] ? mealOptionsList[restaurantId].map(({ name }) => name) : []} // eslint-disable-line max-len
                values={mealOptionsList[restaurantId] ? mealOptionsList[restaurantId].map(({ name }) => name) : []} // eslint-disable-line max-len
                required={true}
                freeSolo
                value={mealItem.name}
                label={`餐點${index + 1} 名稱`}
                onChange={(value)=>{
                  const options = mealOptionsList[restaurantId] || [];
                  const matchedMealItem = options.find(({ name }) => name === value);
                  const cost = (matchedMealItem ? matchedMealItem.cost : 0) || 0;
                  const price = (matchedMealItem ? matchedMealItem.price : 0) || 0;
                  const surcharges = (matchedMealItem ? matchedMealItem.surcharges : []) || [];
                  const updatedMealItems = [...mealItems];
                  updatedMealItems[index] = {
                    name: value,
                    quantity: mealItems[index].quantity || 1,
                    price,
                    cost,
                    note: mealItems[index].note || '',
                    surcharges,
                    subsidyDayOffset: mealItems[index].subsidyDayOffset,
                    subsidyTime: mealItems[index].subsidyTime,
                  };
                  setMealItems(updatedMealItems);
                  handleUpdate(updatedMealItems);
                }}
              />
            </Grid>
            <Grid item md={1}>
              <TextField
                id={`mealItem-quantity`}
                fullWidth
                type="number"
                value={mealItem.quantity}
                required={true}
                label="數量"
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: 0 }}
                onChange={(event) => {
                  const stringValue = event.target.value;
                  const value = stringValue || stringValue === '0' ? parseFloat(stringValue) : '';
                  const updatedMealItems = [...mealItems];
                  updatedMealItems[index].quantity = value;
                  setMealItems(updatedMealItems);
                  handleUpdate(updatedMealItems);
                }}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </Grid>
            <Grid item md={2}>
              <TextField
                id={`mealItem-cost`}
                fullWidth
                type="number"
                value={mealItem.cost}
                required={true}
                label="進價"
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: 0 }}
                onChange={(event) => {
                  const stringValue = event.target.value;
                  const value = stringValue || stringValue === '0' ? parseFloat(stringValue) : '';
                  const updatedMealItems = [...mealItems];
                  updatedMealItems[index].cost = value;
                  setMealItems(updatedMealItems);
                  handleUpdate(updatedMealItems);
                }}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </Grid>
            <Grid item md={2}>
              <TextField
                id={`mealItem-price`}
                fullWidth
                type="number"
                value={mealItem.price}
                required={true}
                label="單價"
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: 0 }}
                onChange={(event) => {
                  const stringValue = event.target.value;
                  const value = stringValue || stringValue === '0' ? parseFloat(stringValue) : '';
                  const updatedMealItems = [...mealItems];
                  updatedMealItems[index].price = value;
                  setMealItems(updatedMealItems);
                  handleUpdate(updatedMealItems);
                }}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </Grid>
            <Grid container item md={3}>
              <Grid item xs>
                <TextField
                  fullWidth
                  type="text"
                  value={mealItem.note}
                  label={'註記'}
                  InputLabelProps={{ shrink: true }}
                  onChange={(event) =>{
                    const value = event.target.value;
                    const updatedMealItems = [...mealItems];
                    updatedMealItems[index].note = value;
                    setMealItems(updatedMealItems);
                    handleUpdate(updatedMealItems);
                  }}
                />
              </Grid>
              {mealItems.length > 1 &&
              <IconButton
                size={'small'}
                style={{
                  width: 40,
                  height: 40,
                }}
                onClick={() => {
                  const updatedMealItems = [...mealItems];
                  updatedMealItems.splice(index, 1);
                  if (index === 0) {
                    delete updatedMealItems[0]?.subsidyDayOffset;
                    delete updatedMealItems[0]?.subsidyTime;
                  }
                  setMealItems(updatedMealItems);
                  handleUpdate(updatedMealItems);
                }}
              >
                <ClearIcon />
              </IconButton>}
            </Grid>
            {index !== 0 && (
              <Grid item md={11} style={{ marginLeft: 'auto' }}>
                <SubsidyDateTimeSetting
                  mealItem={mealItem}
                  onUpdate={(updatedMealItem) => {
                    const updatedMealItems = [...mealItems];
                    updatedMealItems[index] = updatedMealItem;
                    setMealItems(updatedMealItems);
                    handleUpdate(updatedMealItems);
                  }}
                  mealIndex={index}
                />
              </Grid>
            )}
          </Grid>);
      })}
      <Grid container item md={12} justifyContent='center'>
        <Button
          aria-label={'add meal item'}
          size={'small'}
          variant={'text'}
          color={'secondary'}
          style={{ height: '36px' }}
          onClick={() => {
            const updatedMealItems = [...mealItems, getDefaultMealItem()];
            setMealItems(updatedMealItems);
            handleUpdate(updatedMealItems);
          }}
        >
          <AddIcon fontSize="small" />
          新增餐點
        </Button>
      </Grid>
    </>
  );
};

MealItemsWidget.propTypes = {
  registry: PropTypes.object,
  onChange: PropTypes.func,
};

export default MealItemsWidget;
